import {
  TAG_IS_FETCHING,
  TAG_GET,
  TAG_CREATE,
  TAG_REMOVE,
  TAG_EDIT
} from '../types'

const initialState = {
  isFetching: false,
  list: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case TAG_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case TAG_GET:
      return {
        ...state,
        list: action.payload
      }

    case TAG_CREATE:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload
        ]
      }

    case TAG_REMOVE:
      return {
        ...state,
        list: state.list.filter((tag) => tag.id !== action.payload.id)
      }

    case TAG_EDIT:
      return {
        ...state,
        list: [
          ...state.list.map(tag => tag.id === action.payload.id ? action.payload : tag)
        ]

      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/tag.js